import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface OrdersState {
    orderId?: string;
}

const initialState = {
    orderId: undefined,
} satisfies OrdersState as OrdersState;

const ordersSlice = createSlice({
    initialState,
    name: 'orders',
    reducers: {
        orderIdReceived(state, action: PayloadAction<{ orderId: string }>) {
            const {
                orderId,
            } = action.payload;

            state.orderId = orderId;
        },
    },
    selectors: {
        selectOrderId: (state: OrdersState) => state.orderId,
    },
});

export type OrderId = ReturnType<typeof ordersSlice.selectors.selectOrderId>;

export const { actions, selectors } = ordersSlice;
export const { orderIdReceived } = actions;
export default ordersSlice.reducer;
